import { EmailPopoutModal } from "./components/Modal";
import { EmailPopoutModalProps, EmailPopoutOptions } from "./types";
import { confirmable, createConfirmation } from "../../../hooks/DialogMountPoint";

export function openMailPopout(mailType: MailType, mailMessage: MailMessage | null = null, opts: EmailPopoutOptions | null = null) : Promise<MailMessage> {
    return createConfirmation<EmailPopoutModalProps, MailMessage>(confirmable(EmailPopoutModal))({
        dialogId: 'email_popout_modal',
        defaultValues: mailMessage,
        isAttachmentsShownFirst: opts?.isAttachmentsShownFirst ?? true,
        isDocumentSelectorShown: opts?.isDocumentSelectorShown ?? false,
        isForward: mailType === 'forward',
        isReply: mailType === 'reply' || mailType === 'reply-all',
        mailType
    });
}